import React from "react";
import {GridTable} from "../../../Components/Grid";
import {UserApprovalRow} from "./UserApprovalRow";
import {isArrayNullOrEmpty} from "../../../Utilities/Types/arrayUtilities";

interface UserApprovalViewProps {
    handleSetUserSearchCriteria: (criteria: Record<string, unknown>) => void;
    onApprovalStatusClick: (userId: string, value: string | number) => void;
    users: Record<string, any>[];
    redirect: (path: string) => void;
    userSearchCriteria: Record<string, unknown>;
}

export const UserApprovalView: React.FC<UserApprovalViewProps> = ({
                              handleSetUserSearchCriteria,
                              onApprovalStatusClick,
                              users,
                              redirect,
                              userSearchCriteria
                          }) => {

    const handleOrderClick = (event: React.MouseEvent<HTMLTableCellElement>) => {
        let criteria = {...userSearchCriteria} as Record<string, unknown>;
        (criteria as { UpdateSorting: (id: string) => void }).UpdateSorting((event.target as HTMLElement).dataset.id!);
        handleSetUserSearchCriteria(criteria);
    };

    const noResults = isArrayNullOrEmpty(users);

    return (
        <>
            <GridTable className="searchResults" parentClass={`margin--topNone`}>
                <thead>
                <tr>
                    <th onClick={handleOrderClick} className="is-clickable" data-id="email">Email</th>
                    <th onClick={handleOrderClick} className="is-clickable" data-id="firstName">First Name</th>
                    <th onClick={handleOrderClick} className="is-clickable" data-id="lastName">Last Name</th>
                    <th onClick={handleOrderClick} className="is-clickable" data-id="districtName">District /
                        Institution
                    </th>
                    <th onClick={handleOrderClick} className="is-clickable" data-id="patronSubTypeName">Role</th>
                    <th onClick={handleOrderClick} className="is-clickable" data-id="organization">Organization</th>
                    <th onClick={handleOrderClick} className="is-clickable" data-id="approvalStatusName"
                        scope={"col"}>Approval Status
                    </th>
                    <th scope={"col"} className={"align-center"}>
                    Actions
                    </th>
                </tr>
                </thead>
                <tbody>
                {
                    users.map((user, index) => {
                            return (<UserApprovalRow
                                key={index}
                                redirect={redirect}
                                onApprovalStatusClick={onApprovalStatusClick}
                                user={user}
                            />);
                        }
                    )
                }
                {
                    noResults &&
                    <tr data-testid={'no-users-row'}>
                        <td colSpan={8} className={`padding--all text-center`}>No search results found.</td>
                    </tr>
                }
                </tbody>
            </GridTable>
        </>
    );
}
